/**
* 左边菜单
*/ 
<template>
  <el-menu
    :collapse="collapsed"
    collapse-transition
    router
    :default-active="$route.path"
    unique-opened
    class="el-menu-vertical-demo"
    background-color="#334157"
    text-color="#fff"
    active-text-color="#ffd04b"
  >
    <div v-for="menu in allmenu" :key="menu.menuid">
      <el-submenu :index="menu.menuname" v-if="menu.menus">
        <template slot="title">
          <i class="iconfont" :class="menu.icon"></i>
          <span>{{ menu.menuname }}</span>
        </template>
        <el-menu-item-group >
          <el-menu-item
            v-for="chmenu in menu.menus"
            :index="'/' + chmenu.url"
            :key="chmenu.menuid"
          >
            <i class="iconfont" :class="chmenu.icon"></i>
            <span>{{ chmenu.menuname }}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      
      <el-menu-item :index="menu.menuname" v-else>
        <i class="el-icon-setting"></i>
        <span slot="title">{{ menu.menuname }}</span>
      </el-menu-item>

    </div>
  </el-menu>
</template>
<script>
export default {
  name: 'leftnav',
  data () {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created () {
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 1,
          // icon: 'li-icon-dingdanguanli',
          menuname: '首页',
          hasThird: null,
          url: 'index',
          menus: null
        },
        {
          menuid: 2,
          icon: 'icon-cus-manage',
          menuname: '用户管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 21,
              icon: '',
              menuname: '用户管理',
              hasThird: 'N',
              url: 'system/user',
              menus: null
            }
          ]
        },

        {
          menuid: 3,
          icon: 'li-icon-gongsiguanli',
          menuname: '商铺管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 31,
              icon: '',
              menuname: '添加活动分类',
              hasThird: 'N',
              url: 'shop/addActiveCategorize',
              menus: null
            },
            {
              menuid: 32,
              icon: '',
              menuname: '资讯链接',
              hasThird: 'N',
              url: 'shop/information',
              menus: null
            },
            {
              menuid: 33,
              icon: '',
              menuname: '上传轮播图',
              hasThird: 'N',
              url: 'shop/upLoop',
              menus: null
            },
            {
              menuid: 34,
              icon: '',
              menuname: '商品分类管理',
              hasThird: 'N',
              url: 'shop/addCategorize',
              menus: null
            },
            {
              menuid: 35,
              icon: '',
              menuname: '上传活动轮播图',
              hasThird: 'N',
              url: 'shop/upActiveLoop',
              menus: null
            },
            {
              menuid: 36,
              icon: '',
              menuname: '帮助中心',
              hasThird: 'N',
              url: 'shop/helpCenter',
              menus: null
            },
            {
              menuid: 37,
              icon: '',
              menuname: '商品管理',
              hasThird: 'N',
              url: 'goods/Goods',
              menus: null
            },
            {
              menuid: 39,
              icon: '',
              menuname: '专场管理',
              hasThird: 'N',
              url: 'shop/special',
              menus: null
            },
            {
              menuid: 38,
              icon: '',
              menuname: '财务账单',
              hasThird: 'N',
              url: 'shop/financial',
              menus: null
            }
          ]
        },

        {
          menuid: 4,
          icon: 'li-icon-dingdanguanli',
          menuname: '订单管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 41,
              icon: '',
              menuname: '订单管理',
              hasThird: 'N',
              url: 'pay/Order',
              menus: null
            }
          ]
        },
        {
          menuid: 5,
          icon: 'icon-cms-manage',
          menuname: '特权申请',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 51,
              icon: '',
              menuname: '优惠设置',
              hasThird: 'N',
              url: 'system/preferential',
              menus: null
            }
          ]
        },
      ],
      msg: 'success'
    }
    this.allmenu = res.data

    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
.home {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  padding: 10px 0;
  color: #fff;
  text-align: left;
  text-indent: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue